

function Footer() {
    return (
        <>
            <footer className="d-flex py-1 ">
                <p className="text-center text-white mt-1 ">
                    Leon - 2023-2024, All Rights Reserved
                </p>
            </footer>
        </>
    )
}

export default Footer;